<template>
  <div
    :id="`${id}_wrap`"
    :class="{
      'newline': newline,
      'checkbox-wrap': true,
      'checkbox-wrap--state-disabled': disabled,
      'checkbox-wrap--label-right': labelRight
    }">
    <input
      v-if="formInputName"
      type="hidden"
      :name="formInputName"
      :value="checked" />
    <label
      v-if="label && !labelRight"
      :id="`${id}_label`"
      class="label auto-width"
      :for="`${id}_button`"
      >{{ label }}</label
    >
    <button
      :id="`${id}_button`"
      :class="{
        'checkbox': true,
        'checkbox--state-checked': checked,
        'checkbox--state-disabled': disabled,
        'checkbox--state-error': error,
        'validation-field': true
      }"
      type="button"
      tabindex="0"
      role="checkbox"
      :aria-checked="checked"
      :aria-required="required"
      :disabled="disabled"
      @click="onButtonClick">
      <svgicon
        v-if="checked"
        original
        class="checkbox__check"
        role="presentation"
        data="@iconPath/glyph/16/check.svg?inline"
        width="16"
        height="16"></svgicon>
    </button>
    <label
      v-if="label && labelRight"
      :id="`${id}_label`"
      class="label auto-width"
      :for="`${id}_button`"
      >{{ label }}</label
    >
  </div>
</template>

<script>
export default {
  name: 'CheckboxComponent',
  emits: ['change', 'update:modelValue'],
  props: {
    id: String,
    modelValue: Boolean,
    label: String,
    name: String,
    error: Boolean,
    disabled: Boolean,
    newline: Boolean,
    required: Boolean,
    labelRight: {
      type: Boolean,
      default: false
    },
    // This is used if this component is used in a form outside of the legacy code
    formInputName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      checked: false
    }
  },
  created() {
    this.checked = this.modelValue
  },
  watch: {
    modelValue() {
      if (this.checked !== this.modelValue) {
        this.checked = this.modelValue
      }
    }
  },
  methods: {
    onButtonClick() {
      this.checked = !this.checked
      this.$emit('change', this.checked)
      this.$emit('update:modelValue', this.checked)
    }
  }
}
</script>
